import { Badge } from "@odingard/design-system";

// Demo-mode banner: rendered whenever the Worker answered Policy AI from the
// deterministic fixture layer, so fixture data is never mistaken for governed
// policy records.
export function PolicyDemoBanner({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <div className="ods-failclosed" role="status" style={{ borderColor: "var(--ods-color-warning)" }}>
      <strong>Demo data.</strong> Policy AI is running against the deterministic fixture layer, not a live
      backend. Records below are illustrative and are not governed evidence.
    </div>
  );
}

export function PolicyLiveBadge({ demoMode }: { demoMode: boolean }) {
  if (demoMode) return null;
  return <Badge tone="success">Live backend</Badge>;
}
